<script setup lang="ts">
import { useToast } from '@/hooks';

const { showToast } = useToast();
</script>

<template>
  <main class="min-h-screen">
    <Toast v-if="showToast" />
    <RouterView />
  </main>
</template>
